import { onMounted, ref } from "vue";
import { useTrpc } from "@app/vue/providers/index";
import type { StaffMember } from "./types";

/** The shop's active staff, for assigning tasks. */
export function useStaff() {
  const trpc = useTrpc();
  const staff = ref<StaffMember[]>([]);
  onMounted(async () => {
    try {
      const list = await trpc.staff.list.query();
      staff.value = (list as { id: number; name: string; status: string }[])
        .filter((s) => s.status !== "inactive")
        .map((s) => ({ id: s.id, name: s.name }));
    } catch {
      staff.value = [];
    }
  });
  return staff;
}
